const stripEnvQuotes = (value: string | undefined) =>
  (value || "").trim().replace(/^['"]|['"]$/g, "").replace(/\/+$/, "");

const getApiBaseUrl = () =>
  stripEnvQuotes(
    process.env.REACT_APP_BASE_URL || process.env.REACT_APP_API_BASE_URL
  );

export async function getActivePinCode() {
  try {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };
    const apiKey = stripEnvQuotes(process.env.REACT_APP_CREATIVE_API_KEY);
    if (apiKey) headers["X-API-Key"] = apiKey;

    const apiBaseUrl = getApiBaseUrl();
    if (!apiBaseUrl) {
      return {
        success: false as const,
        error: "API base URL is not configured. Set REACT_APP_BASE_URL.",
      };
    }

    const response = await fetch(`${apiBaseUrl}/admin/pin-code/public`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const errorText = await response.text();
      return {
        success: false as const,
        error: `Failed to fetch PIN code: ${response.status} ${errorText}`,
      };
    }

    const data = await response.json();
    if (data?.pinCode) {
      return { success: true as const, pinCode: String(data.pinCode) };
    }
    return { success: false as const, error: "Invalid response format from API" };
  } catch (error) {
    return {
      success: false as const,
      error:
        error instanceof Error
          ? error.message
          : "Network error while fetching PIN code",
    };
  }
}
